import $ from 'jquery';

export default class jumpAnotherPage {
  constructor() {
    this.clickCurrentURL();
  }
  clickCurrentURL() {
    $('a').on('click', (e) => {
      let clickedURL = $(e.currentTarget).attr('href')
      if(location.pathname === clickedURL) {
        e.preventDefault();
      }
    })
  }
}


// WEBPACK FOOTER //
// ./dev/js/jump_to_another_page.js